/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconGeneralSettings from './nav-icon-general-settings.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconGeneralSettings {...validProps} />;
}
SvgComponent.iconName = 'navIconGeneralSettings';

export const NavIconGeneralSettingsIcon = svgIconWrapper(SvgComponent);
